<template>
  <p>
    Du kommer få ett nytt nummer tillsammans med det nya simkortet vi skickar
    till dig senare.
  </p>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss"></style>
